export type UiLang = "en" | "ar" | "fr";

const dict = {
  en: {
    joinTitle: "Join a live session",
    joinSubtitle: "Enter the session code from your screen or QR code",
    sessionCode: "Session code",
    joinButton: "Continue",
    chooseLanguage: "Choose your listening language",
    startListening: "Start listening",
    connecting: "Connecting…",
    connected: "Connected",
    reconnecting: "Reconnecting…",
    disconnected: "Disconnected",
    waitingForSpeaker: "Waiting for the speaker to begin…",
    sessionPaused: "The session is paused",
    sessionEnded: "This session has ended. Thank you for joining.",
    leave: "Leave",
    changeLanguage: "Change language",
    audioOn: "Spoken audio: on",
    audioOff: "Spoken audio: off",
    notFound: "Session not found. Please check the code and try again.",
    poweredBy: "Arab Fertilizer Association — Live Interpretation",
    installApp: "Install app",
    aiDisclaimer: "Live AI translation, it may contain errors.",
  },
  ar: {
    joinTitle: "الانضمام إلى جلسة مباشرة",
    joinSubtitle: "أدخل رمز الجلسة الظاهر على الشاشة أو امسح رمز الاستجابة السريعة",
    sessionCode: "رمز الجلسة",
    joinButton: "متابعة",
    chooseLanguage: "اختر لغة الاستماع",
    startListening: "ابدأ الاستماع",
    connecting: "جارٍ الاتصال…",
    connected: "متصل",
    reconnecting: "إعادة الاتصال…",
    disconnected: "غير متصل",
    waitingForSpeaker: "في انتظار بدء المتحدث…",
    sessionPaused: "الجلسة متوقفة مؤقتًا",
    sessionEnded: "انتهت هذه الجلسة. شكرًا لانضمامكم.",
    leave: "مغادرة",
    changeLanguage: "تغيير اللغة",
    audioOn: "الصوت المنطوق: يعمل",
    audioOff: "الصوت المنطوق: متوقف",
    notFound: "لم يتم العثور على الجلسة. يرجى التحقق من الرمز والمحاولة مرة أخرى.",
    poweredBy: "الجمعية العربية للأسمدة — الترجمة الفورية",
    installApp: "تثبيت التطبيق",
    aiDisclaimer: "ترجمة آلية فورية بالذكاء الاصطناعي، وقد تحتوي على أخطاء غير مقصودة.",
  },
  fr: {
    joinTitle: "Rejoindre une session en direct",
    joinSubtitle: "Saisissez le code de session affiché à l'écran ou scannez le code QR",
    sessionCode: "Code de session",
    joinButton: "Continuer",
    chooseLanguage: "Choisissez votre langue d'écoute",
    startListening: "Commencer l'écoute",
    connecting: "Connexion…",
    connected: "Connecté",
    reconnecting: "Reconnexion…",
    disconnected: "Déconnecté",
    waitingForSpeaker: "En attente du début de l'intervention…",
    sessionPaused: "La session est en pause",
    sessionEnded: "Cette session est terminée. Merci de votre participation.",
    leave: "Quitter",
    changeLanguage: "Changer de langue",
    audioOn: "Audio parlé : activé",
    audioOff: "Audio parlé : désactivé",
    notFound: "Session introuvable. Vérifiez le code et réessayez.",
    poweredBy: "Association Arabe des Engrais — Interprétation en direct",
    installApp: "Installer l'application",
    aiDisclaimer: "Traduction automatique par IA, des erreurs involontaires sont possibles.",
  },
} as const;

export type StringKey = keyof (typeof dict)["en"];

export function t(lang: UiLang, key: StringKey): string {
  return dict[lang]?.[key] ?? dict.en[key];
}

export function directionOf(lang: string): "ltr" | "rtl" {
  return lang === "ar" ? "rtl" : "ltr";
}

// Best-effort mapping from our language codes to BCP-47 tags for
// SpeechSynthesis voice selection.
export function bcp47(languageCode: string): string {
  switch (languageCode) {
    case "ar":
      return "ar-SA";
    case "fr":
      return "fr-FR";
    case "en":
    default:
      return "en-US";
  }
}
